export const MY_ACTION_PLANS_PENDING = "MY_ACTION_PLANS_PENDING";
export const MY_ACTION_PLANS_FULFILLED = "MY_ACTION_PLANS_FULFILLED";
export const MY_ACTION_PLANS_REJECTED = "MY_ACTION_PLANS_REJECTED";

export const MY_REPORTERS_ACTION_PLANS_PENDING = "MY_REPORTERS_ACTION_PLANS_PENDING";
export const MY_REPORTERS_ACTION_PLANS_FULFILLED = "MY_REPORTERS_ACTION_PLANS_FULFILLED";
export const MY_REPORTERS_ACTION_PLANS_REJECTED = "MY_REPORTERS_ACTION_PLANS_REJECTED";

export const ACTION_PLANS_PENDING = "ACTION_PLANS_PENDING";
export const ACTION_PLANS_FULFILLED = "ACTION_PLANS_FULFILLED";
export const ACTION_PLANS_REJECTED = "ACTION_PLANS_REJECTED";
